/**
 * @generated SignedSource<<c8d0547d7fa2ee6de5c94eb484db49fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildPresentationsScreenOtherPresentationsSection_guild$data = {
  readonly id: string;
  readonly otherPresentations: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"PresentationCardNew_presentation">;
      };
    }>;
  };
  readonly " $fragmentType": "GuildPresentationsScreenOtherPresentationsSection_guild";
};
export type GuildPresentationsScreenOtherPresentationsSection_guild$key = {
  readonly " $data"?: GuildPresentationsScreenOtherPresentationsSection_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildPresentationsScreenOtherPresentationsSection_guild">;
};

import GuildPresentationsScreenOtherPresentationsSectionPaginationQuery_graphql from './GuildPresentationsScreenOtherPresentationsSectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "otherPresentations"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": GuildPresentationsScreenOtherPresentationsSectionPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "GuildPresentationsScreenOtherPresentationsSection_guild",
  "selections": [
    {
      "alias": "otherPresentations",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "CREATED_AT_DESC",
            "ID_ASC"
          ]
        },
        {
          "kind": "Literal",
          "name": "timeSelection",
          "value": "OTHER"
        }
      ],
      "concreteType": "PresentationsConnection",
      "kind": "LinkedField",
      "name": "__GuildPresentationsScreenOtherPresentationsSection_guild_otherPresentations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PresentationsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Presentation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PresentationCardNew_presentation"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__GuildPresentationsScreenOtherPresentationsSection_guild_otherPresentations_connection(orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"],timeSelection:\"OTHER\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};
})();

(node as any).hash = "e39177f4a7d1666dd91d5f527f650aa6";

export default node;
